import * as msal from "@azure/msal-browser";
import api from "../.././../core/utils/apis/api";
const useMicrosoftLogin = () => {

  const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_AZURE_CLIENT_ID, // Your client ID
      redirectUri: process.env.REACT_APP_HOST, // Your redirect URL
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true,
    },
  };
  const msalInstance = new msal.PublicClientApplication(msalConfig);
  // Use the useLocalStorage hook to store tokens
  const loginMicrosoft = async () => {
    try {
      await msalInstance.initialize();
      const response = await msalInstance.loginPopup({
        scopes: "user.read".split(" "),
        prompt: "select_account",
      });

      if (response && response.account) {
        console.log("response", response);
        const res = await api.post("/auth/sso", {
          loginData: response,
        });
        localStorage.setItem("accessToken", res.data.accessToken);
        localStorage.setItem("refreshToken", res.data.refreshToken);
        if (sessionStorage.getItem("lastPage")) {
          window.location.href = sessionStorage.getItem("lastPage");
          sessionStorage.removeItem("lastPage");
        } else{
          window.location.href = "/";
        }

      }
    } catch (err) {
      console.error("Microsoft login error:", err);
    }
  };

  return {
    loginMicrosoft
  };
};

export default useMicrosoftLogin;
